var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select',{staticClass:"wd-100p",attrs:{"filterable":"","clearable":"","disabled":_vm.disabled},on:{"change":_vm.ProjectChange},model:{value:(_vm.selectedProject),callback:function ($$v) {_vm.selectedProject=$$v},expression:"selectedProject"}},_vm._l((_vm.projects),function(p){return _c('Option',{key:p.id,attrs:{"value":p.id,"label":p.nm}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }